import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL;

export const MakeAuthenticationRequest = async (
  endpoint,
  method = "GET",
  data = null,
  headers = {} // ✅ Accept headers as a parameter
) => {
  try {
    const storedUser = localStorage.getItem("userData");
    if (!storedUser) {
      localStorage.removeItem("userData");
      throw new Error("User is not authenticated");
    }

    const { token } = JSON.parse(storedUser);

    const config = {
      method: method,
      url: `${apiURL}${endpoint}`,
      headers: {
        "auth-token": `${token}`,
        ...headers, // ✅ Merge custom headers
      },
      data: data,
    };

    const response = await axios(config);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to make authenticated request!");
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error("Failed to make authenticated request!");
    }
  }
};



export const getTotalUserCount = async () => {
  try {
    const response = await MakeAuthenticationRequest("user/fetchdashboard");
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllUsers = async () => {
  try {
    const response = await MakeAuthenticationRequest("user/fetchallusers");
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchUserByEmailAddress = async (email) => {
  try {
    const response = await MakeAuthenticationRequest(
      `user/fetchuserbyemail/${email}`
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateUserProfile = async (data) => {
  try {
    const response = await MakeAuthenticationRequest(
      `user/updateuserbyemail/${data.email}`,
      "PUT",
      data
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateWalletByEmailAddress = async (data) => {
  try {
    const response = await MakeAuthenticationRequest(
      `user/updateuserwalletbyemail/${data.email}`,
      "PUT",
      data
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllProducts = async () => {
  try {
    const response = await MakeAuthenticationRequest("product/getallproducts");
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};


export const AddProductsCsv = async (file) => {
  if (!file) {
    console.error("No file selected");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  // 🔍 Debugging: Check if FormData contains the file
  for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]); // Should log: file, [File Object]
  }

  try {
    const response = await MakeAuthenticationRequest(
      "product/csvupload",
      "POST",
      formData,
      {
        "Content-Type": "multipart/form-data", // ✅ Now properly passed
      }
    );

    return response;
  } catch (error) {
    console.error("Upload Error:", error);
    throw new Error(error.message);
  }
};


export const getAllOrders = async () => {
  try {
    const response = await MakeAuthenticationRequest("orders/getallorders");
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getOrderDetails = async (orderId) => {
  try {
    const response = await MakeAuthenticationRequest(
      `orders/oredrdetail/${orderId}`
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateOrderStatus = async (orderId, orderStatus) => {
  try {
    const response = await MakeAuthenticationRequest(
      `orders/updatestatus/${orderId}`,
      "PUT",
      { orderStatus }
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateInventory = async (file) => {
  if (!file) {
    console.error("No file selected");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  // 🔍 Debugging: Check if FormData contains the file
  for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]); // Should log: file, [File Object]
  }

  try {
    const response = await MakeAuthenticationRequest(
      "product/updateInventory",
      "POST",
      formData,
      {
        "Content-Type": "multipart/form-data", // ✅ Now properly passed
      }
    );

    return response;
  } catch (error) {
    console.error("Upload Error:", error);
    throw new Error(error.message);
  }
};